export interface RouterSSHResponse {
  stdOut:string
  stdErr:string
  exit:string
  error?:any
}